import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("pf_admin_token", res.data.access_token);
      localStorage.setItem("pf_admin_email", res.data.email);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6 pf-grid-bg">
      <div className="w-full max-w-md bg-white border border-slate-100 rounded-3xl p-8 md:p-10 shadow-sm">
        <div className="flex items-center gap-2 mb-8">
          <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-slate-900 overflow-hidden">
            <img src="/phoenix-icon.png" alt="" className="h-full w-full object-cover" />
          </span>
          <span className="pf-heading text-lg font-semibold text-slate-900">
            The Phoenix Fix · Admin
          </span>
        </div>
        <h1 className="pf-heading text-3xl font-semibold tracking-tight text-slate-900">
          Sign in
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          Access bookings and manage specials.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@thephoenixfix.com"
              data-testid="admin-login-email"
              className="mt-2 h-11"
            />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              data-testid="admin-login-password"
              className="mt-2 h-11"
            />
          </div>
          <Button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full h-12 rounded-xl bg-slate-900 hover:bg-blue-700 text-white font-semibold"
          >
            <LogIn className="h-4 w-4 mr-2" />
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <p className="mt-6 text-xs text-slate-400 text-center">
          Contact your administrator if you need access.
        </p>
      </div>
    </div>
  );
}
